// @flow

import React from 'react'
import {getSessionPartnerId} from '@/partnerID'
import CreditsafeLogo from '@/assets/img/logo.jpg'
import EquifaxLogo from '@/assets/img/Equifax_Logo.png'

type Props = {
  onClick: () => void,
}

const selectImgSrc = (partnerID: any) => {
  switch (partnerID) {
    case 'cs':
      return CreditsafeLogo
    case 'efx':
      return EquifaxLogo
    default:
      return CreditsafeLogo
  }
}
export default (props: Props) => <a onClick={props.onClick}><img className="logo" src={selectImgSrc(getSessionPartnerId())} alt="logo"/></a>



// WEBPACK FOOTER //
// ./src/elements/logo.js